// Orice Redus BF: timerul Black Friday, meniul mobil, galeria, butonul „Comandă acum” și bara de jos.
(() => {
  // Timer Black Friday: numără până la data din Setări temă (ora României), nu se resetează
  const endIso = document.body.dataset.bfEnd || '';
  const [d, t = '23:59'] = endIso.split('T');
  if (d) {
    const [Y, M, D] = d.split('-').map(Number);
    const [h, m] = t.split(':').map(Number);
    const end = new Date(Y, M - 1, D, h, m, 59);
    const fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    const roNow = () => {
      const p = Object.fromEntries(fmt.formatToParts(new Date()).map((x) => [x.type, x.value]));
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    };
    const pad = (n) => String(n).padStart(2, '0');
    const set = (sel, val) => document.querySelectorAll(sel).forEach((x) => (x.textContent = val));
    const tick = () => {
      let s = Math.floor((end - roNow()) / 1000);
      const live = s > 0;
      document.querySelectorAll('[data-bf], [data-bf-inline]').forEach((x) => (x.hidden = !live));
      if (!live) return clearInterval(timer);
      const dd = Math.floor(s / 86400); s -= dd * 86400;
      const hh = Math.floor(s / 3600); s -= hh * 3600;
      const mm = Math.floor(s / 60); s -= mm * 60;
      set('[data-bf-d]', pad(dd)); set('[data-bf-h]', pad(hh)); set('[data-bf-m]', pad(mm)); set('[data-bf-s]', pad(s));
      set('[data-bf-short]', (dd > 0 ? dd + 'z ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(s));
    };
    const timer = setInterval(tick, 1000);
    tick();
  }

  // Meniu mobil
  const drawer = document.getElementById('drawer');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open="drawer"]')) { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-close]')) { drawer.hidden = true; document.body.style.overflow = ''; }
  });

  // Galerie: glisare, miniaturi, contor
  document.querySelectorAll('[data-gal]').forEach((gal) => {
    const track = gal.querySelector('[data-gal-track]');
    const thumbs = [...gal.querySelectorAll('[data-go]')];
    const cur = gal.querySelector('[data-gal-cur]');
    const mark = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (cur) cur.textContent = i + 1;
      thumbs.forEach((x, k) => x.classList.toggle('is-on', k === i));
      const th = thumbs[i];
      if (th) th.parentElement.scrollTo({ left: th.offsetLeft - th.parentElement.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
    };
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach((x) => x.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * +x.dataset.go, behavior: 'smooth' })));
    // Săgețile: trec la poza anterioară / următoare (de la ultima revin la prima)
    const n = track.children.length;
    // ținta se păstrează cât timp poza încă alunecă, ca apăsările rapide să nu se piardă
    let target = null, reset;
    const step = (d) => {
      const i = target ?? Math.round(track.scrollLeft / track.clientWidth);
      target = (i + d + n) % n;
      track.scrollTo({ left: track.clientWidth * target, behavior: 'smooth' });
      clearTimeout(reset);
      reset = setTimeout(() => { target = null; }, 700);
    };
    gal.querySelector('[data-gal-prev]')?.addEventListener('click', () => step(-1));
    gal.querySelector('[data-gal-next]')?.addEventListener('click', () => step(1));
  });

  // Comandă acum: adaugă în coș, apoi checkout direct sau coș
  const cfgEl = document.querySelector('[data-buy-cfg]');
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { direct: false, checkout: '/checkout', cart: '/cart' };
  const form = document.querySelector('[data-buy]');
  if (!form) return;
  const btn = form.querySelector('[data-buy-main]');
  const err = form.querySelector('[data-buy-err]');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    btn.classList.add('is-loading');
    err.hidden = true;
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Nu am putut adăuga produsul.');
      window.location.href = cfg.direct ? cfg.checkout : cfg.cart;
    } catch (x) {
      err.textContent = x.message;
      err.hidden = false;
      btn.classList.remove('is-loading');
    }
  });
  document.querySelectorAll('[data-sticky-btn]').forEach((b) => b.addEventListener('click', () => form.requestSubmit()));

  // Bara de jos: apare după ce butonul principal a ieșit din ecran în sus
  const dock = document.querySelector('[data-sticky]');
  if (dock && btn) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      dock.hidden = !show;
      document.body.classList.toggle('has-dock', show);
    }).observe(btn);
  }
})();

// Clipurile MP4 din galerie și carduri: pornesc singure; dacă browserul nu le redă (Low Power Mode, eroare), pun GIF-ul
(() => {
  const toGif = (v) => {
    if (!v.isConnected || !v.dataset.gif) return;
    const img = new Image();
    img.src = v.dataset.gif;
    img.alt = v.getAttribute('aria-label') || '';
    img.className = 'or-vid-gif';
    v.replaceWith(img);
  };
  const play = (v) => {
    const p = v.play();
    if (p && p.catch) p.catch((e) => { if (e && e.name === 'NotAllowedError') toGif(v); });
  };
  // Erorile se ascultă doar după ce clipul are sursă (un <source> fără src dă și el eroare)
  const arm = (v) => {
    v.querySelector('source')?.addEventListener('error', () => toGif(v));
    if (v.readyState >= 2) play(v); else v.addEventListener('loadeddata', () => play(v), { once: true });
  };
  // Clipurile care nu sunt primele pe pagină se încarcă doar când ajung aproape de ecran
  const lazy = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target: v }) => {
      if (!isIntersecting) return;
      lazy.unobserve(v);
      const s = v.querySelector('source[data-src]');
      if (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); }
      v.removeAttribute('data-lazy');
      arm(v);
      v.load();
    });
  }, { rootMargin: '200px 200px' });
  document.querySelectorAll('video.or-vid').forEach((v) => {
    v.muted = true;
    if (v.hasAttribute('data-lazy')) lazy.observe(v); else arm(v);
  });
})();

// Prețul se schimbă odată cu varianta aleasă
(() => {
  const data = document.querySelector('[data-p-variants]');
  const sel = document.querySelector('[data-variant]');
  if (!data || !sel) return;
  const map = JSON.parse(data.textContent);
  const now = document.querySelector('[data-p-now]');
  const was = document.querySelector('[data-p-was]');
  const save = document.querySelector('[data-p-save]');
  sel.addEventListener('change', () => {
    const v = map[sel.value];
    if (!v) return;
    now.textContent = v.p;
    was.hidden = save.hidden = !v.c;
    if (v.c) { was.textContent = v.c; save.textContent = '−' + v.s; }
  });
})();
